/* eslint-disable jsx-a11y/alt-text */
import axios from "axios";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import { useEffect, useMemo, useRef, useState } from "react";
import { Accordion } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Countdown from "react-countdown";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ReactComponent as DiamondIcon } from "../../assets/diamond.svg";
import { ReactComponent as DiscountIcon } from "../../assets/discount.svg";
import { ReactComponent as GuaranteeIcon } from "../../assets/guaranteeIcon.svg";
import noncod from "../../assets/non-cod.jpg";
import Offer from "../../assets/offer.jpg";
import {
  default as faAssuredPlus,
  default as faPlusAssured,
} from "../../assets/plusassured.jpg";
import replacement from "../../assets/replacement.jpg";
import { ReactComponent as ShippingIcon } from "../../assets/shipping.svg";
import { ReactComponent as TrustIcon } from "../../assets/trusticon.svg";
import { useAuth } from "../../contexts/AuthContext";
import OfferCountdown from "../Header/OfferCountdown";
import ProductCard from "../ProductCard";
import SkeletonLoader from "../SkeletonLoader";
import "./index.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Spinner from "../Spinner";

function ThumbnailPlugin(mainRef) {
  return (slider) => {
    function removeActive() {
      slider.slides.forEach((slide) => {
        slide.classList.remove("active");
      });
    }
    function addActive(idx) {
      slider.slides[idx].classList.add("active");
    }

    function addClickEvents() {
      slider.slides.forEach((slide, idx) => {
        slide.addEventListener("click", () => {
          if (mainRef.current) mainRef.current.moveToIdx(idx);
        });
      });
    }

    slider.on("created", () => {
      if (!mainRef.current) return;
      addActive(slider.track.details.rel);
      addClickEvents();
      mainRef.current.on("animationStarted", (main) => {
        removeActive();
        const next = main.animator.targetIdx || 0;
        addActive(main.track.absToRel(next));
        slider.moveToIdx(Math.min(slider.track.details.maxIdx, next));
      });
    });
  };
}

const SingleProduct = () => {

  const { id } = useParams();
  const [selectedSizes, setSelectedSizes] = useState({});
  const [sizeErrors, setSizeErrors] = useState({});
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [pinCode, setPinCode] = useState("");
  const [relatedItems, setRelatedItems] = useState([]);
  const sizeSectionRef = useRef(null);
  const location = useLocation();

  const pageURL = window.location.pathname; // auto detect current page
  const [views, setViews] = useState(0);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await fetch(
  //         `${process.env.REACT_APP_PAYMENT_NODE_URL
  //         }/api/ga4/realtime?url=${encodeURIComponent(pageURL)}`
  //       );
  //       const data = await response.json();
  //       console.log("==============>response", response);
  //       console.log("==============>data", data);
  //       if (data.success) {
  //         setViews(data.activeUsersLast30Min);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching GA data:", error);
  //     }
  //   };

  //   // Fetch the data immediately
  //   fetchData();

  //   // Refresh the data every 30 seconds (or other interval)
  //   const intervalId = setInterval(fetchData, 30000);

  //   // Cleanup interval on component unmount
  //   return () => clearInterval(intervalId);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [pageURL]);

  // useEffect(() => {
  //   const productId = location.pathname.match(/\/single-product\/([a-z0-9]+)/i)?.[1];
  //   const fetchData = async () => {
  //     setLoading(true);
  //     try {
  //       // Call the last 30 minutes endpoint
  //       const response = await fetch(
  //         `${process.env.REACT_APP_PAYMENT_NODE_URL}/api/ga4/last30min?productId=${productId}`
  //       );

  //       if (!response.ok) {
  //         throw new Error(`HTTP error! status: ${response.status}`);
  //       }

  //       const data = await response.json();

  //       if (data.success) {
  //         // Set the active users count from last 30 minutes
  //         setViews(data.activeUsersLast30Min);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching GA data:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   // Fetch the data immediately
  //   fetchData();

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [pageURL]);

  const handlePinCodeChange = (event) => {
    const { value } = event.target;
    if (/^\d*$/.test(value) && value.length <= 6) {
      setPinCode(value);
    }
  };

  const handleSelectSize = (type, option) => {
    setSelectedSizes((prev) => ({
      ...prev,
      [type]: option,
    }));

    // Clear error for this type
    setSizeErrors((prev) => ({
      ...prev,
      [type]: false,
    }));
  };
  const servicesIcon = [
    {
      icons: <DiamondIcon />,
      name: "PREMIUM QUALITY",
    },
    {
      icons: <ShippingIcon />,
      name: "SHIPPING FREE",
    },
    {
      icons: <GuaranteeIcon />,
      name: "BEST PRICE GUARANTEE",
    },
    {
      icons: <TrustIcon />,
      name: "VERIFIED AND SECURED",
    },
  ];

  const isPinCodeValid = pinCode.length === 6;

  const {
    handleSetCartProducts,
    cartProducts,
    setIsRelatedVisible,
    setSingleProduct,
    handleShowCart,
    singleProduct,
  } = useAuth();
  const ref = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const relatedSection = document.getElementById("related-products");
      if (relatedSection) {
        const rect = relatedSection.getBoundingClientRect();
        setIsRelatedVisible(rect.top < window.innerHeight && rect.bottom > 0);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [setIsRelatedVisible]);

  useEffect(() => {
    if (ref?.current) {
      if (["STOPPED", "COMPLETED"].includes(ref?.current?.state?.status)) {
        ref?.current?.start();
      }
    }
  }, [location, ref]);

  const [singleData, setSingleData] = useState(singleProduct);
  const [selectedImage, setSelectedImage] = useState(null);
  const [reletedProduct, setReletedProduct] = useState([]);

  const openFullScreen = () => {
    if (instanceRef.current) {
      const currentSlide = instanceRef.current.track.details.rel;
      setSelectedImage(singleData?.images[currentSlide]);
    }
  };
  const sliderContainerRef = useRef(null);
  const [sliderRef, instanceRef] = useKeenSlider(
    {
      loop: true,
      mode: "snap",
      origin: "center",
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel);
        const activeSlide = slider.slides[slider.track.details.rel];
        if (activeSlide && sliderContainerRef.current) {
          const img = activeSlide.querySelector("img");
          if (img) {
            sliderContainerRef.current.style.height = img.offsetHeight + "px";
          }
        }
      },
      slides: {
        perView: 1,
      },
    },
    []
  );

  const [thumbnailRef, thumbnailInstanceRef] = useKeenSlider(
    {
      initial: 0,
      slides: {
        perView: 4,
        spacing: 10,
      },
    },
    [ThumbnailPlugin(instanceRef)]
  );

  useEffect(() => {
    instanceRef?.current?.update();
    thumbnailInstanceRef?.current?.update();

    setTimeout(() => {
      const active =
        instanceRef?.current?.slides[instanceRef.current.track.details.rel];
      if (active && sliderContainerRef.current) {
        const img = active.querySelector("img");
        if (img) {
          sliderContainerRef.current.style.height = img.offsetHeight + "px";
        }
      }
    }, 300);
  }, [singleData?.images]);

  useEffect(() => {
    const cacheKey = `product_${id}`;
    const cachedData = sessionStorage.getItem(cacheKey);

    if (cachedData) {
      const parsed = JSON.parse(cachedData);
      const now = Date.now();
      const age = now - parsed.timestamp;

      if (age < 5 * 60 * 1000) {
        setSingleData(parsed.data.product);
        setSingleProduct(parsed.data.product);
        setReletedProduct(parsed.data.relatedProducts);
        setRelatedItems(parsed.data.product.relatedItems);
        setIsLoading(false);
        return;
      } else {
        sessionStorage.removeItem(cacheKey);
      }
    }
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/products/${id}`)
      .then((res) => {
        const dataToStore = {
          data: {
            product: res?.data?.product,
            relatedProducts: res?.data?.relatedProducts,
          },
          timestamp: Date.now(),
        };

        sessionStorage.setItem(cacheKey, JSON.stringify(dataToStore));

        setSingleData(res?.data?.product);
        setSingleProduct(res?.data?.product);
        setReletedProduct(res?.data?.relatedProducts);
        setRelatedItems(res?.data?.product?.relatedItems);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // useEffect(() => {
  //   if (singleProduct._id !== id) {
  //     setIsLoading(true);
  //   }
  //   axios
  //     .get(`${process.env.REACT_APP_API_URL}/api/products/${id}`)
  //     .then((res) => {
  //       setSingleData(res?.data?.product);
  //       setSingleProduct(res?.data?.product);
  //       setReletedProduct(res?.data?.relatedProducts);
  //       setRelatedItems(res?.data?.product?.relatedItems);
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [id]);
  const [loading, setLoading] = useState(false);
  const [productImage, setProductImage] = useState([]);

  useEffect(() => {
    if (relatedItems?.length > 0) {
      setLoading(true); // Show spinner before fetching data

      axios
        .post(`${process.env.REACT_APP_API_URL}/api/products/images`, {
          productIds: relatedItems,
        })
        .then((res) => setProductImage(res.data.products || []))
        .catch((err) => console.error("Error fetching product images", err))
        .finally(() => setLoading(false));
    }
  }, [relatedItems]);

  const buttonStyle = {
    backgroundColor: "white",
    border: "1px solid #ccc",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
  };

  // const images = singleData?.images || [];
  const images = useMemo(() => singleData?.images || [], [singleData?.images]);

  const handlePrev = () => {
    const currentIndex = images.indexOf(selectedImage);
    if (currentIndex > 0) {
      setSelectedImage(images[currentIndex - 1]);
    }
  };

  const handleNext = () => {
    const currentIndex = images.indexOf(selectedImage);
    if (currentIndex < images.length - 1) {
      setSelectedImage(images[currentIndex + 1]);
    }
  };

  const [quantity, setQuantity] = useState(1);

  const handleDecrement = () => {
    if (quantity > 1) {
      const newQty = quantity - 1;
      setQuantity(newQty);
    }
  };

  const handleIncrement = () => {
    const newQty = quantity + 1;
    setQuantity(newQty);
  };

  const updateCartProduct = () => {
    let errors = {};
    let hasError = false;

    singleData?.sizes?.forEach((group) => {
      if (!selectedSizes[group.type]) {
        errors[group.type] = true;
        hasError = true;
      }
    });

    if (hasError) {
      setSizeErrors(errors);
      return;
    }

    setSizeErrors({});
    const existingProduct = cartProducts?.find((o) => o._id === id);
    if (!existingProduct) {
      handleSetCartProducts([
        ...cartProducts,
        { ...singleData, quantity: quantity, selectedSizes },
      ]);
    }
    handleShowCart();
  };

  const [thumbLoaded, setThumbLoaded] = useState([]);
  const preloaderRunningRef = useRef(false);

  useEffect(() => {
    if (!images?.length) return;
    setThumbLoaded(Array(images.length).fill(false));
    preloaderRunningRef.current = false;
  }, [images]);

  const startSequentialPreload = (startIndex = 1) => {
    if (preloaderRunningRef.current) return;
    preloaderRunningRef.current = true;

    const loadOne = (i) => {
      if (i >= images.length) return;
      const src = images[i];
      const im = new Image();
      im.onload = () => {
        setThumbLoaded((prev) => {
          const next = [...prev];
          next[i] = true;
          return next;
        });
        loadOne(i + 1); // go to next
      };
      im.onerror = () => {
        // even if it fails, mark as ready and continue
        setThumbLoaded((prev) => {
          const next = [...prev];
          next[i] = true;
          return next;
        });
        loadOne(i + 1);
      };
      im.src = src;
    };

    // tiny delay so first frame paints
    setTimeout(() => loadOne(startIndex), 50);
  };

  const percentOff =
    singleData?.price && singleData?.discount
      ? (
        ((singleData.price - singleData.discount) / singleData.price) *
        100
      ).toFixed(0)
      : null;
  const hashInt = (s = "") => {
    let h = 0;
    for (let i = 0; i < s.length; i++) h = s.charCodeAt(i) + ((h << 5) - h);
    return Math.abs(h);
  };

  const computeReviewCountFromSingle = (singleData) => {
    const seed =
      String(singleData?._id || "") + "|" + String(singleData?.title || "");
    const base = hashInt(seed);
    const min = 900,
      max = 12000; // 0.9K..12K
    let num = (base % (max - min)) + min;

    const rating = Number(singleData?.rating) || 4.2;
    const scale = 0.85 + (rating / 5) * 0.55;
    return Math.round(num * scale);
  };

  const formatCount = (n) =>
    n >= 1000 ? (n / 1000).toFixed(1).replace(/\.0$/, "") + "K+" : String(n);

  const ratingValue = Number(singleData?.rating) || 4.3;

  const reviewCount = useMemo(() => {
    if (singleData?.reviewCount != null) return Number(singleData.reviewCount);
    return computeReviewCountFromSingle(singleData);
  }, [
    singleData?._id,
    singleData?.title,
    singleData?.rating,
    singleData?.reviewCount,
  ]);

  // Live viewers:
  const [liveViewers, setLiveViewers] = useState(100);
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    const update = () => {
      const delta =
        Math.floor(Math.random() * 80 + 8) * (Math.random() < 0.5 ? -1 : 1);

      setLiveViewers((v) => {
        const next = Math.max(30, Math.min(150, v + delta));
        return next;
      });

      setPulse(true);
      setTimeout(() => setPulse(false), 380);

      timer = setTimeout(update, 2000 + Math.random() * 3000);
    };

    let timer = setTimeout(update, 1500);
    return () => clearTimeout(timer);
  }, []);

  const TOTAL_STOCK = 100;
  const [stockLeft, setStockLeft] = useState(70);

  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

  useEffect(() => {
    let timer;
    const tick = () => {
      const step = Math.floor(Math.random() * 2) + 1; // 2–5
      setStockLeft((prev) => clamp(prev - step, 10, TOTAL_STOCK));
      timer = setTimeout(tick, 10000 + Math.random() * 10000);
    };
    timer = setTimeout(tick, 200);
    return () => clearTimeout(timer);
  }, []);

  const rating = Math.max(0, Math.min(5, Number(ratingValue) || 0));
  return (
    <div className="single_product_block">
      <Container>
        {isLoading ? (
          <Col className="d-flex justify-content-center">
            <Spinner isSinglePage />
          </Col>
        ) : (
          <Row className="g-4 align-items-start">
            <Col xs={12} lg={6} className="px-0">
              <div className="p-0 m-0">
                <div className="position-relative">
                  {images.length > 0 && (
                    // NEW: wrapper with adaptive height
                    <div
                      ref={sliderContainerRef}
                      className="w-full transition-all duration-300 overflow-hidden"
                    >
                      <div
                        ref={sliderRef}
                        className="keen-slider position-relative"
                      >
                        {images.map((item, index) => (
                          <div
                            key={`slide-${index}`}
                            className="keen-slider__slide relative shrink-0"
                          >
                            {process.env.REACT_APP_themssizetype ===
                              "Portrait" ? (
                              <img
                                src={item}
                                alt={window.location.hostname}
                                onClick={() => setSelectedImage(item)}
                                style={{
                                  maxHeight: "600px",
                                  width: "100%",
                                  objectFit: "contain",
                                }}
                                loading={index === 0 ? "eager" : "lazy"} // NEW
                                decoding="async" // NEW
                                fetchPriority={index === 0 ? "high" : "low"} // NEW
                              />
                            ) : (
                              <img
                                src={item}
                                alt={window.location.hostname}
                                onClick={() => setSelectedImage(item)}
                                style={{ width: "100%", objectFit: "contain" }}
                                loading={index === 0 ? "eager" : "lazy"} // NEW
                                decoding="async" // NEW
                                fetchPriority={index === 0 ? "high" : "low"} // NEW
                              />
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Touch to zoom */}
                  <div
                    className="position-absolute text-white"
                    style={{
                      background: "rgba(0, 0, 0, 0.5)",
                      bottom: 10,
                      right: 0,
                      left: 0,
                      margin: "auto",
                      width: "max-content",
                      borderRadius: 10,
                      padding: "2px 12px",
                    }}
                    onClick={() => setSelectedImage(images[currentSlide])}
                  >
                    Touch to zoom
                  </div>
                </div>

                {/* Dots */}
                <div>
                  <div className="dots" style={{ background: "unset" }}>
                    {(images || []).map((img, idx) => (
                      <button
                        key={`dot-${idx}`}
                        onClick={() => instanceRef?.current?.moveToIdx(idx)}
                        className={
                          "dot" + (currentSlide === idx ? " active" : "")
                        }
                      ></button>
                    ))}
                  </div>

                  {/* Thumbnails */}
                  <div ref={thumbnailRef} className="keen-slider thumbnail">
                    {images.map((img, index) => {
                      if (index === 0) {
                        return (
                          <div
                            key={`thumb-${index}`}
                            onClick={() =>
                              instanceRef.current?.moveToIdx(index, true)
                            }
                            className={`keen-slider__slide number-slide${index + 1
                              }`}
                            style={{ "--borderColor": "var(--them-color)" }}
                          >
                            <img
                              src={img}
                              alt={`thumb-${index}`}
                              style={{
                                height: "100%",
                                width: "100%",
                                objectFit: "cover",
                              }}
                              loading="eager" // NEW
                              decoding="async" // NEW
                              fetchPriority="high" // NEW
                              onLoad={() => {
                                setThumbLoaded((prev) => {
                                  const next = [...prev];
                                  next[0] = true;
                                  return next;
                                });
                                startSequentialPreload(1); // NEW
                              }}
                              onError={() => {
                                setThumbLoaded((prev) => {
                                  const next = [...prev];
                                  next[0] = true;
                                  return next;
                                });
                                startSequentialPreload(1); // NEW
                              }}
                            />
                          </div>
                        );
                      }

                      const ready = !!thumbLoaded[index];
                      return (
                        <div
                          key={`thumb-${index}`}
                          onClick={() =>
                            instanceRef.current?.moveToIdx(index, true)
                          }
                          className={`keen-slider__slide number-slide${index + 1
                            }`}
                          style={{ "--borderColor": "var(--them-color)" }}
                        >
                          {ready ? (
                            <img
                              src={img}
                              alt={`thumb-${index}`}
                              style={{
                                height: "100%",
                                width: "100%",
                                objectFit: "cover",
                              }}
                              loading="lazy"
                              decoding="async"
                              fetchPriority="low"
                            />
                          ) : (
                            <SkeletonLoader
                              style={{
                                height: "100%",
                                width: "100%",
                                borderRadius: 6,
                              }}
                            />
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* Fullscreen Overlay */}
                {selectedImage && (
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 1050,
                      flexDirection: "column",
                    }}
                  >
                    <div style={{ width: "100%" }}>
                      <img
                        src={selectedImage}
                        alt="Full-Screen"
                        style={{ width: "100%", borderRadius: "4px" }}
                      />
                      <div
                        style={{
                          display: "flex",
                          gap: "35px",
                          marginTop: "10px",
                          alignItems: "center",
                          justifyContent: "center",
                          position: "fixed",
                          left: 0,
                          right: 0,
                          bottom: 30,
                        }}
                      >
                        <button onClick={handlePrev} style={buttonStyle}>
                          <svg
                            height="25px"
                            width="25px"
                            viewBox="0 0 284.49 498.98"
                          >
                            <path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0Z"></path>
                          </svg>
                        </button>
                        <button
                          onClick={() => setSelectedImage(null)}
                          style={{
                            backgroundColor: "white",
                            border: "1px solid #ccc",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            fontSize: "18px",
                            padding: "30px",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="#000000"
                            height="20px"
                            width="20px"
                            viewBox="0 0 490 490"
                          >
                            <polygon points="456.851,0 245,212.564 33.149,0 0.708,32.337 212.669,245.004 0.708,457.678 33.149,490 245,277.443 456.851,490 489.292,457.678 277.331,245.004 489.292,32.337 " />
                          </svg>
                        </button>
                        <button onClick={handleNext} style={buttonStyle}>
                          <svg
                            height="25px"
                            width="25px"
                            viewBox="0 0 284.49 498.98"
                          >
                            <path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98Z"></path>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </Col>

            <Col xs={12} lg={6} className="pt-lg-5 p-lg-5 mt-0">
              <div className="pb-2 ref-wrap">
                <p className="mb-1 ref-title">{singleData?.description}</p>

                <div className="d-flex align-items-center mb-2 ref-stars-line mt-lg-2">
                  <span className="ref-stars">
                    {[1, 2, 3, 4, 5].map((n) => {
                      const isFull = rating >= n;
                      return (
                        <i
                          key={n}
                          className={
                            isFull
                              ? "fa-solid fa-star star star--full"
                              : "fa-regular fa-star star"
                          }
                        />
                      );
                    })}
                  </span>

                  <span className="ref-review-text ms-2">
                    ( {ratingValue?.toFixed(1)}/5 · {formatCount(reviewCount)}{" "}
                    Happy Buyers )
                  </span>
                </div>

                <div className="d-flex align-items-center justify-content-between flex-wrap ref-price-row">
                  <div className="d-flex align-items-center gap-1 flex-wrap">
                    <span className="ref-price">
                      <span>₹</span>
                      {singleData?.discount || singleData?.price}
                    </span>

                    {singleData?.discount && (
                      <>
                        <span className="ref-mrp">
                          <span>₹</span> {singleData?.price}
                        </span>
                        {percentOff && (
                          <span className="ref-badge">{percentOff}% OFF</span>
                        )}
                      </>
                    )}
                  </div>

                  <span
                    className="live-viewers"
                    style={{
                      boxShadow: pulse
                        ? "0 0 0 6px rgba(46, 204, 113, 0.18)"
                        : "none",
                      transform: pulse ? "scale(1.06)" : "scale(1)",
                      opacity: pulse ? 1 : 0.9,
                    }}
                    aria-live="polite"
                  >
                    <i
                      className="fa-solid fa-circle"
                      style={{
                        fontSize: 8,
                        color: pulse ? "#16a34a" : "#22c55e",
                        transition: "color 220ms ease",
                      }}
                    />
                    <span>Live Views : {liveViewers.toLocaleString()}</span>
                  </span>
                </div>
              </div>

              {singleData?.sizes?.length > 0 && (
                <div className="px-lg-0 mt-lg-3">
                  <div
                    className="my-1 select-options-box"
                    style={{ textAlign: "start" }}
                    ref={sizeSectionRef}
                  >
                    {singleData?.sizes?.map((sizeGroup, index) => (
                      <div key={index} className="mb-3">
                        <p style={{ fontWeight: 600, margin: "0 0 8px" }}>
                          Select{" "}
                          {sizeGroup.type.charAt(0).toUpperCase() +
                            sizeGroup.type.slice(1)}
                        </p>

                        {/* Options */}
                        <div className="d-flex align-items-center flex-wrap gap-2">
                          {sizeGroup.options.map((option, idx) => (
                            <span
                              key={idx}
                              onClick={() =>
                                handleSelectSize(sizeGroup.type, option)
                              }
                              className={`option-item ${selectedSizes[sizeGroup.type] === option
                                ? "active"
                                : ""
                                }`}
                            >
                              {option}
                            </span>
                          ))}
                        </div>

                        {/* Error */}
                        {sizeErrors[sizeGroup.type] && (
                          <p
                            className="shake-error text-danger mt-1"
                            style={{ fontSize: "14px" }}
                          >
                            Please select {sizeGroup.type}
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {relatedItems?.length > 0 && (
                <div className="mb-3">
                  <h5>Available On</h5>
                  <div>
                    {loading ? (
                      <Row
                        xs={4}
                        md={4}
                        className="g-2 m-0"
                        style={{ paddingLeft: "2px" }}
                      >
                        {[...Array(4)].map((_, index) => (
                          <Col key={index}>
                            <Skeleton height={90} width="100%" />
                          </Col>
                        ))}
                      </Row>
                    ) : (
                      productImage.length > 0 && (
                        <div className="main_variant">
                          {productImage.map((p) => {
                            const matchedItem = relatedItems.find(
                              (item) => item._id === p._id
                            );
                            const displayName =
                              matchedItem?.name &&
                                matchedItem.name.trim() !== ""
                                ? matchedItem.name
                                : singleData?.description || "No Description";
                            return (
                              <div
                                className="flex flex-column align-items-center"
                                key={p._id}
                                onClick={() =>
                                  navigate(`/single-product/${p._id}`)
                                }
                                style={{ cursor: "pointer", margin: "7px" }}
                              >
                                <img src={p.image} alt={p.title} />
                                <p
                                  className="mt-1 text-center"
                                  style={{ fontSize: "13px" }}
                                >
                                  {displayName?.length > 10
                                    ? `${displayName.slice(0, 10)}...`
                                    : displayName}
                                </p>
                              </div>
                            );
                          })}
                        </div>
                      )
                    )}
                  </div>
                </div>
              )}
              <div
                className="container-fluid px-3 pt-2 d-flex justify-content-end"
                style={{ textAlign: "center" }}
              >
                <h4 className="m-0">
                  <span>
                    <Countdown
                      date={Date.now() + parseInt(500000)}
                      ref={ref}
                      renderer={(e) => <OfferCountdown />}
                      intervalDelay={1000}
                    />
                  </span>
                </h4>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "6px 10px",
                  background: stockLeft <= 15 ? "#FFF5F5" : "#F5F5F5",
                  borderRadius: "10px",
                  width: "fit-content",
                  border:
                    stockLeft <= 15 ? "1px solid #FF4C4C" : "1px solid #DCDCDC",
                  transition: "0.3s ease",
                }}
              >
                <div
                  style={{
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    background: stockLeft <= 15 ? "#FF1E1E" : "#4CAF50",
                    animation:
                      stockLeft <= 15
                        ? "pulse 1s infinite ease-in-out"
                        : "none",
                  }}
                />

                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: stockLeft <= 15 ? "#C10000" : "#333",
                  }}
                >
                  {stockLeft} Left
                </span>
              </div>

              <div
                style={{
                  height: 10,
                  borderRadius: 999,
                  background: "#e5e5e5",
                  marginTop: 8,
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    height: "100%",
                    width: `${(stockLeft / TOTAL_STOCK) * 100}%`,
                    background: "linear-gradient(90deg, #14532d, #22c55e)",
                    borderRadius: 999,
                    transition: "width 0.6s ease-in-out",
                  }}
                />
              </div>

              <div className="d-flex flex-row justify-content-between align-items-center gap-3 mt-2 mt-lg-3">
                {/* Quantity Toggle */}
                <div
                  className="toggle-amount mt-2"
                  style={{
                    border: `1px solid ${process.env.REACT_APP_THEAM_COLOR}`,
                    width: "130px",
                  }}
                >
                  <div>
                    <i
                      className="fa-solid fa-minus"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDecrement();
                      }}
                    ></i>
                  </div>
                  <div className="amount">{quantity}</div>
                  <div>
                    <i
                      className="fa-solid fa-plus"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleIncrement();
                      }}
                    ></i>
                  </div>
                </div>

                {/* Add to Cart Button */}
                <button
                  className="add-cart-btn text-white fw-medium mt-2 d-flex align-items-center justify-content-center gap-2"
                  style={{
                    background: "var(--them-color)",
                    border: "none",
                    borderRadius: 8,
                    whiteSpace: "nowrap",
                  }}
                  onClick={updateCartProduct}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{ color: "white", marginRight: "8px" }}
                  >
                    <circle cx="9" cy="21" r="1"></circle>
                    <circle cx="20" cy="21" r="1"></circle>
                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                  </svg>
                  Add to cart
                </button>

                {/* Buy Now Button (Visible on LG only) */}
                <button
                  className="d-none d-lg-flex align-items-center justify-content-center fw-bold text-white mt-2"
                  style={{
                    background: process.env.REACT_APP_THEAM_COLOR,
                    border: "none",
                    padding: "13px 40px",
                    borderRadius: 8,
                    whiteSpace: "nowrap",
                  }}
                  onClick={(e) => {
                    let errors = {};
                    let hasError = false;

                    singleData?.sizes?.forEach((group) => {
                      if (!selectedSizes[group.type]) {
                        errors[group.type] = true;
                        hasError = true;
                      }
                    });

                    if (hasError) {
                      setSizeErrors(errors);
                      sizeSectionRef.current?.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                      });
                      return;
                    }

                    setSizeErrors({});

                    if (cartProducts?.find((o) => o._id === id)) {
                      navigate("/cart");
                    } else {
                      handleSetCartProducts([
                        ...cartProducts,
                        { ...singleData, quantity: 1, selectedSizes },
                      ]);
                      e?.target?.classList?.add("bounceIn");
                      setTimeout(() => {
                        if (e?.target?.classList?.contains("bounceIn"))
                          e?.target?.classList?.remove("bounceIn");
                      }, 1000);
                      navigate("/cart");
                    }
                  }}
                >
                  <svg
                    width="21"
                    height="21"
                    fill="#ffffff"
                    className="me-2"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.894 4.546v11.796a.5.5 0 0 0 .837.369l6.74-6.18a.5.5 0 0 0-.017-.752l-6.74-5.617a.5.5 0 0 0-.82.384ZM11.894 4.546v11.796a.5.5 0 0 0 .837.369l6.74-6.18a.5.5 0 0 0-.017-.752l-6.74-5.617a.5.5 0 0 0-.82.384Z"
                      fill="#fff"
                    ></path>
                  </svg>
                  BUY NOW
                </button>
              </div>

              <div
                className="position-relative text-start mt-3 mx-auto"
                style={{ maxWidth: 420 }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 373 112"
                  className="w-100"
                  style={{ display: "block" }}
                >
                  <defs>
                    <radialGradient
                      id="diamondGradient"
                      cx="50%"
                      cy="50%"
                      r="70%"
                    >
                      <stop offset="0%" stopColor="#FFFFFF" />
                      <stop offset="100%" stopColor="#FFFFFF" />
                    </radialGradient>
                    <linearGradient
                      id="borderGradient"
                      x1="186.5"
                      y1="2"
                      x2="186.5"
                      y2="102"
                    >
                      <stop stopColor="#000000" />
                      <stop offset="1" stopColor="#000000" />
                    </linearGradient>
                  </defs>

                  <path
                    d="M352 1.5C360.56 1.5 367.5 8.43959 367.5 17V41.1084C367.5 43.5767 366.296 45.7612 365.215 47.8018C364.108 49.8904 363.122 51.8374 363.247 53.9932C363.368 56.0647 364.371 57.9764 365.415 60.0137C366.437 62.0087 367.5 64.1272 367.5 66.4678V87C367.5 95.5604 360.56 102.5 352 102.5H21C12.4396 102.5 5.5 95.5604 5.5 87V63.7139C5.5 62.2418 6.06962 60.4101 6.74316 58.6807C7.41915 56.945 8.24139 55.2142 8.77344 53.9814C9.84871 51.4899 9.12764 49.2333 8.0332 46.75C6.95905 44.3127 5.5 41.6319 5.5 38.5557V17C5.5 8.43959 12.4396 1.5 21 1.5H352Z"
                    fill="url(#diamondGradient)"
                    stroke="url(#borderGradient)"
                  />

                  <text
                    x="20"
                    y="34"
                    textAnchor="start"
                    fontSize="14"
                    fontWeight="600"
                    fill="#000000"
                  >
                    INSTANT DISCOUNT OFFERS
                  </text>

                  <line
                    x1="20"
                    y1="50"
                    x2="353"
                    y2="50"
                    stroke="#6B7280"
                    strokeDasharray="3 3"
                  />
                </svg>

                <div
                  className="position-absolute top-0 start-0 w-100 d-flex align-items-center gap-2"
                  style={{
                    marginTop: 58,
                    paddingLeft: 14,
                    paddingRight: 16,
                  }}
                >
                  <i
                    className="bi bi-tag-fill"
                    style={{ fontSize: 18, color: "#111" }}
                  />
                  <span
                    className="fs-6 d-flex align-items-center mt-0 mt-lg-2"
                    style={{ gap: "8px", fontSize: "10px" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 25 25"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_1_51)">
                        <path
                          d="M15.274 10.1437C15.1302 10.2885 15.1146 10.4812 15.2302 10.7234C15.3432 10.9651 15.5854 11.2682 15.9547 11.6328C16.3234 11.9963 16.6307 12.2359 16.8766 12.35C17.124 12.4635 17.3187 12.4469 17.4615 12.3021C17.737 12.0234 17.5083 11.5224 16.776 10.8C16.0484 10.0833 15.5479 9.86405 15.274 10.1437Z"
                          fill="black"
                        />
                        <path
                          d="M14.6224 -0.00172424L0 14.6228L10.3786 24.9998L25.0016 10.3759V0.00140076L14.6224 -0.00172424ZM11.4047 15.1524C10.9328 15.6327 10.3943 15.8337 9.79167 15.7535C9.1901 15.6764 8.56302 15.316 7.9125 14.6738C6.5849 13.3634 6.4151 12.2071 7.40469 11.205C7.88854 10.7139 8.43281 10.5071 9.03646 10.5837C9.6401 10.6603 10.262 11.0144 10.9021 11.6452C11.5698 12.3045 11.9443 12.929 12.025 13.5181C12.1047 14.1087 11.8979 14.6535 11.4047 15.1524ZM13.812 17.6384L10.9281 7.81703L11.9604 6.77067L14.8432 16.5936L13.812 17.6384ZM18.351 13.1972C17.8776 13.6759 17.3396 13.8785 16.737 13.7983C16.1349 13.7207 15.5094 13.3623 14.8609 12.7228C13.5333 11.4123 13.3641 10.2561 14.3526 9.25296C14.8375 8.76234 15.3818 8.55505 15.9859 8.63213C16.5885 8.70869 17.2115 9.06234 17.85 9.69307C18.5156 10.3493 18.888 10.9738 18.9687 11.5629C19.05 12.153 18.8443 12.6983 18.351 13.1972ZM22.225 4.97484C21.6177 5.58161 20.6339 5.58161 20.0245 4.97588C19.4177 4.36703 19.4177 3.38265 20.0234 2.7738C20.6318 2.1665 21.6182 2.1665 22.225 2.77275C22.8339 3.38317 22.8349 4.36598 22.225 4.97484Z"
                          fill="black"
                        />
                        <path
                          d="M8.32396 12.0943C8.17969 12.2401 8.16511 12.4338 8.28021 12.675C8.39375 12.9167 8.63594 13.2198 9.00469 13.5849C9.37344 13.949 9.68073 14.1875 9.92709 14.301C10.1729 14.4156 10.3688 14.4 10.512 14.2542C10.7859 13.9755 10.5583 13.4745 9.82657 12.7516C9.09948 12.0349 8.59844 11.8167 8.32396 12.0943Z"
                          fill="black"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1_51">
                          <rect width="25" height="25" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span style={{ fontSize: "14px", fontWeight: "500" }}>
                      Buy 2 Get 1 Free
                    </span>
                    <span
                      className="text-secondary"
                      style={{ fontSize: "14px" }}
                    >
                      (Add 3 items to cart)
                    </span>
                  </span>
                </div>
              </div>

              <div className="">
                <Row className="text-center">
                  {servicesIcon?.map((service, index) => (
                    <Col key={index} md={3} sm={6} xs={3} className="my-1">
                      <div className="service-card">
                        <span className="service-icon">{service.icons}</span>
                        <p className="service-title m-0">{service.name}</p>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </Col>

            {process.env.REACT_APP_FLIPASSURED_IMAGE === "yes" && (
              <>
                <div
                  className="container-fluid p-3 mb-1 card"
                  style={{ marginTop: "5px" }}
                >
                  <img src={Offer} alt={window.location.hostname} />
                </div>

                <div
                  className="container-fluid px-2 py-3 d-flex feature-container product-extra card"
                  style={{ flexDirection: "row" }}
                >
                  <div className="col-4 featured-item d-flex align-items-center flex-column bd-highlight px-1">
                    <img
                      className="featured-img mb-1"
                      src={replacement}
                      alt={window.location.hostname}
                      height="35"
                    />
                    <span className="feature-title"> 7 days Replacement </span>
                  </div>
                  <div className="col-4 featured-item d-flex align-items-center flex-column bd-highlight px-1">
                    <img
                      alt={window.location.hostname}
                      className="featured-img mb-1"
                      src={noncod}
                      height="35"
                    />
                    <span className="feature-title"> No Cash On Delivery </span>
                  </div>
                  <div className="col-4 featured-item d-flex align-items-center flex-column bd-highlight px-1">
                    <img
                      className="featured-img mb-1 mt-1"
                      src={faPlusAssured}
                      alt={window.location.hostname}
                      height="30"
                    />
                    <span className="feature-title"> Plus (F-Assured) </span>
                  </div>
                </div>
              </>
            )}
            <Col xs={12}>
              {singleData.productDetails && (
                <div>
                  <h6 className="card-title text-start fw-bold mb-3">
                    Product Details
                  </h6>

                  {singleData.product_video && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `
        <video
         width="100%"
          loop
          muted
          autoplay
          playsinline
          src="${singleData.product_video}"
          className="video-background"
        />,
      `,
                      }}
                    ></div>
                  )}

                  <div
                    className="disImage"
                    dangerouslySetInnerHTML={{
                      __html: singleData.productDetails,
                    }}
                  />
                </div>
              )}
            </Col>
            <div className="cardification" />
            <Col xs={12}>
              <div>
                {" "}
                <Accordion className="p-0 mb-3">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>DELIVERY TIME</Accordion.Header>
                    <Accordion.Body className="">
                      <div
                        style={{ color: "rgb(40, 44, 63)", fontSize: "16px" }}
                        className="my-3"
                      >
                        It Will take Max 4 to 7 Days For Delivery In India.
                      </div>
                      <a
                        href=""
                        style={{ color: "black", fontWeight: "500" }}
                        onClick={() => navigate("/shippingpolicy")}
                      >
                        View More
                      </a>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>RETURN & EXCHANGE</Accordion.Header>
                    <Accordion.Body>
                      <div
                        style={{ color: "rgb(40, 44, 63)", fontSize: "13px" }}
                        className="my-3"
                      >
                        We have a friendly replacement policy to ensure your
                        online purchase is free of stress. We offer 7 Days
                        Exchange for our valued customers. We are always with
                        you, before your purchase and after your purchase. We
                        are not perfect but we have ensured that our replacement
                        policies do not bring any ugly surprises to you post
                        your purchase
                      </div>
                      <a
                        href=""
                        style={{ color: "black", fontWeight: "500" }}
                        onClick={() => navigate("/refund-policy")}
                      >
                        View More
                      </a>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>Company Details</Accordion.Header>
                    <Accordion.Body>
                      <div
                        style={{ color: "rgb(40, 44, 63)", fontSize: "13px" }}
                        className="my-3"
                      >
                        <p className="">
                          <span className="fw-bold">Company Name:</span> &nbsp;
                         {window.location.hostname.replace(/^www\./, "").split(".")[0]} , {process.env.REACT_APP_FAM}
                        </p>
                        <p className="">
                          <span className="fw-bold">Email:</span> support@{window.location.hostname.replace(/^www\./, "")}
                        </p>
                        <p className="">
                          <span className="fw-bold"> Registered Address:</span>
                          &nbsp;
                          {process.env.REACT_APP_ADDRESS}
                        </p>
                        
                        <p className="">
                          <span className="fw-bold"> FSSAI Registrations/Lincense No. :</span>
                          &nbsp;
20725022003841
                        </p>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </Col>
            {/* <div className="cardification" /> */}
            <div className="mt-1 pb-1">
              <div className="image-banner-table">
                <div className="image-banner-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="37"
                    height="37"
                    viewBox="0 0 37 37"
                    fill="none"
                  >
                    <path
                      d="M18.5639 2.14629L17.424 3.72558L15.7619 2.70952L15.3137 4.60462L13.3893 4.30161L13.7006 6.22416L11.8065 6.68066L12.8302 8.33771L11.2552 9.48385L12.8351 10.623L11.8187 12.2846L13.7145 12.7326L13.4115 14.6566L15.3347 14.3453L15.7911 16.2387L17.4486 15.2154L18.5951 16.7899L19.7349 15.2105L21.397 16.2265L21.7065 14.9178L21.8453 14.3313L23.7699 14.6344L23.4585 12.7117L25.3526 12.2554L24.3288 10.5985L25.904 9.45234L24.3241 8.31293L25.3404 6.6514L23.4446 6.20335L23.7474 4.27935L21.8244 4.5906L21.3678 2.69724L19.7103 3.72052L18.5637 2.146L18.5639 2.14629ZM18.5456 5.88097C19.4974 5.88097 20.4101 6.25892 21.0831 6.93166C21.7561 7.6044 22.1341 8.51684 22.1341 9.46824C22.1341 10.4196 21.756 11.332 21.0831 12.0047C20.4101 12.6774 19.4974 13.0553 18.5457 13.0554C17.594 13.0553 16.6813 12.6774 16.0084 12.0047C15.3355 11.332 14.9574 10.4196 14.9574 9.46824C14.9574 8.51685 15.3354 7.60442 16.0084 6.93168C16.6813 6.25894 17.5941 5.88099 18.5458 5.88097H18.5456ZM22.8342 15.8036L22.2502 18.2725L20.0851 16.949L19.3807 17.9248C20.2287 23.8535 20.6887 29.7645 23.3303 35.7744L24.5266 30.9915C25.2861 31.9899 26.5153 32.8745 28.115 33.383C25.8693 27.7783 25.0242 21.8937 24.161 16.0125L22.8342 15.8036ZM14.3524 15.8219L12.9245 16.0532C12.0633 21.9207 11.2168 27.7911 8.97644 33.383C10.5761 32.8745 11.8054 31.9899 12.565 30.9915L13.7611 35.7745C16.4201 29.7252 16.8689 23.776 17.7278 17.8083L17.1067 16.9555L14.9474 18.2883L14.3525 15.822L14.3524 15.8219Z"
                      fill="#252D4E"
                    />
                  </svg>
                  <div className="image-banner-text">Genuine Products</div>
                </div>
                <div className="image-banner-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="26"
                    height="26"
                    viewBox="0 0 26 26"
                    fill="none"
                  >
                    <path
                      d="M12.875 14.2451C13.969 14.2451 15.0182 13.8105 15.7918 13.0369C16.5654 12.2633 17 11.2141 17 10.1201C17 9.0261 16.5654 7.97689 15.7918 7.2033C15.0182 6.42971 13.969 5.99512 12.875 5.99512C11.781 5.99512 10.7318 6.42971 9.95818 7.2033C9.1846 7.97689 8.75 9.0261 8.75 10.1201C8.75 11.2141 9.1846 12.2633 9.95818 13.0369C10.7318 13.8105 11.781 14.2451 12.875 14.2451Z"
                      stroke="#252D4E"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M4.33658 15.0288L0.5 20.516L4.66658 21.7535L7.25114 25.2463L11.1286 19.7188M21.4141 15.0288L25.25 20.5154L21.0841 21.7529L18.4989 25.2456L14.6214 19.7181"
                      stroke="#283861"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M22.8852 10.1202C22.8852 11.1656 21.9638 12.0454 21.6609 12.9806C21.3586 13.9152 21.5652 15.1943 20.9738 16.0054C20.3825 16.8165 19.1172 16.9954 18.3747 17.6006C17.6322 18.2058 17 19.3331 16.0377 19.6493C15.0747 19.9654 13.9884 19.3602 12.9436 19.3602C11.8988 19.3602 10.7854 19.9515 9.85019 19.6493C8.91497 19.3463 8.32361 18.1775 7.51247 17.6006C6.70067 17.0231 5.43611 16.8165 4.84475 16.0054C4.25339 15.1936 4.47383 13.9429 4.15769 12.9806C3.84089 12.0177 2.86475 11.1656 2.86475 10.1202C2.86475 9.07474 3.78611 8.19562 4.08839 7.2604C4.39067 6.32518 4.18475 5.04676 4.77611 4.23562C5.36747 3.42448 6.63269 3.24562 7.44383 2.6404C8.25497 2.03518 8.74997 0.907896 9.78089 0.591756C10.8125 0.274956 11.8302 0.880177 12.875 0.880177C13.9197 0.880177 15.0332 0.288816 15.969 0.591756C16.9036 0.894036 17.495 2.0629 18.3747 2.6404C19.2545 3.2179 20.4511 3.42382 21.0425 4.23562C21.6338 5.04742 21.414 6.29812 21.7302 7.2604C22.0463 8.22268 22.8852 9.0754 22.8852 10.1202Z"
                      stroke="#283861"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <div className="image-banner-text mt-1">
                    7 Step Quality Check
                  </div>
                </div>
                <div className="image-banner-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="31"
                    viewBox="0 0 32 31"
                    fill="none"
                  >
                    <path
                      d="M16 0.568359L29.3333 5.08919V15.5C29.3333 20.8307 25.956 24.5572 22.8053 26.8706C20.9047 28.2545 18.819 29.3821 16.6053 30.2224L16.4893 30.2651L16.456 30.2767L16.4466 30.2793L16.4426 30.2806C16.4413 30.2806 16.44 30.2806 16 29.0625L15.5586 30.2819L15.5533 30.2793L15.544 30.2767L15.5106 30.2638L15.3946 30.2224C14.7658 29.9869 14.1474 29.7257 13.5413 29.4397C12.0111 28.7196 10.5556 27.8593 9.19463 26.8706C6.04529 24.5572 2.66663 20.8307 2.66663 15.5V5.08919L16 0.568359ZM16 29.0625L15.5586 30.2819L16 30.4317L16.4413 30.2819L16 29.0625ZM16 27.6779L16.012 27.6727C17.8568 26.934 19.5982 25.9727 21.1946 24.8117C24.0453 22.7204 26.6666 19.6631 26.6666 15.5V6.92336L16 3.30669L5.33329 6.92336V15.5C5.33329 19.6631 7.95463 22.7179 10.8053 24.8129C12.4053 25.9762 14.1507 26.9388 16 27.6779ZM24.096 10.7764L14.668 19.9098L9.01063 14.4305L10.8973 12.6028L14.6666 16.2569L22.2093 8.94998L24.096 10.7764Z"
                      fill="#252D4E"
                    />
                  </svg>
                  <div className="image-banner-text">Secure Payments</div>
                </div>
              </div>
            </div>
            <div className="cardification" />
            <div className="pt-2 pb-2 position-sticky bottom-0 d-lg-none">
              <div className="d-flex justify-content-center align-items-center">
                <Button
                  className="btn primary d-flex justify-content-between align-items-center ripple animated w-100"
                  style={{
                    padding: "12px 20px",
                    borderRadius: "15px",
                    background: process.env.REACT_APP_THEAM_COLOR,
                    borderColor: process.env.REACT_APP_THEAM_COLOR,
                  }}
                  variant="dark"
                  onClick={(e) => {
                    let errors = {};
                    let hasError = false;

                    singleData?.sizes?.forEach((group) => {
                      if (!selectedSizes[group.type]) {
                        errors[group.type] = true;
                        hasError = true;
                      }
                    });

                    if (hasError) {
                      setSizeErrors(errors);
                      sizeSectionRef.current?.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                      });
                      return;
                    }

                    setSizeErrors({});

                    if (cartProducts?.find((o) => o._id === id)) {
                      navigate("/cart");
                    } else {
                      handleSetCartProducts([
                        ...cartProducts,
                        { ...singleData, quantity: 1, selectedSizes },
                      ]);
                      e?.target?.classList?.add("bounceIn");
                      setTimeout(() => {
                        if (e?.target?.classList?.contains("bounceIn"))
                          e?.target?.classList?.remove("bounceIn");
                      }, 1000);
                      navigate("/cart");
                    }
                  }}
                >
                  {/* <span>
                    <span
                      style={{
                        fontSize: "15px",
                        color: "#f7f7ff",
                      }}
                    >
                      Sales End Soon
                    </span>
                    <div className="Timer-Up">
                      <Countdown date={Date.now() + parseInt(process.env.REACT_APP_OFFER_TIME)} ref={ref}  renderer={(e) => <OfferCountdown {...e} isButton/>} intervalDelay={1000} />
                    </div>
                  </span> */}

                  {singleData?.price &&
                    (singleData?.discount ? (
                      <p style={{ textAlign: "center" }} className="mb-0">
                        <span
                          style={{
                            color: "#878585",
                            marginRight: "5px",
                            textDecoration: "line-through",
                            fontWeight: "bold",
                          }}
                        >
                          {" "}
                          ₹{singleData?.price}{" "}
                        </span>
                        <span
                          style={{
                            fontWeight: 700,
                            color: "white",
                            fontSize: "25px",
                          }}
                        >
                          {" "}
                          <span style={{ fontSize: "12px" }}>₹</span>
                          {singleData.discount.toFixed(0)}{" "}
                        </span>
                        <span
                          style={{
                            color: "darkgreen",
                            marginLeft: "5px",
                            fontWeight: "bold",
                          }}
                        >{`${(
                          ((singleData?.price - singleData.discount) /
                            singleData?.price) *
                          100
                        ).toFixed(0)}% OFF`}</span>
                      </p>
                    ) : (
                      <p style={{ textAlign: "left" }} className="mb-0">
                        {singleData.price}
                      </p>
                    ))}
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <svg
                      width="21"
                      height="21"
                      fill="#ffffff"
                      className="me-2"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.894 4.546v11.796a.5.5 0 0 0 .837.369l6.74-6.18a.5.5 0 0 0-.017-.752l-6.74-5.617a.5.5 0 0 0-.82.384ZM11.894 4.546v11.796a.5.5 0 0 0 .837.369l6.74-6.18a.5.5 0 0 0-.017-.752l-6.74-5.617a.5.5 0 0 0-.82.384Z"
                        fill="#fff"
                      ></path>
                    </svg>
                    {cartProducts?.find((o) => o._id === id)?._id ? (
                      "BUY NOW"
                    ) : (
                      <span style={{ fontWeight: "bold" }}>BUY NOW</span>
                    )}
                  </span>
                </Button>
              </div>
            </div>

            <div className="mt-4 pb-4 container " id="related-products">
              <h6
                className="card-title text-center fw-bold mb-3 "
                style={{ fontSize: "20px" }}
              >
                Trending On Socials Right Now
              </h6>
              <Slider
                infinite={true}
                speed={500}
                slidesToShow={5}
                centerMode={true}
                centerPadding="5%"
                arrows={false}
                responsive={[
                  {
                    breakpoint: 1200,
                    settings: {
                      slidesToShow: 5,
                      centerMode: true,
                      centerPadding: "5%",
                    },
                  },
                  {
                    breakpoint: 992,
                    settings: {
                      slidesToShow: 4,
                      centerMode: true,
                      centerPadding: "5%",
                    },
                  },
                  {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 3,
                      centerMode: true,
                      centerPadding: "5%",
                    },
                  },
                  {
                    breakpoint: 576,
                    settings: {
                      slidesToShow: 2,
                      centerMode: true,
                      centerPadding: "5%",
                    },
                  },
                ]}
              >
                {reletedProduct
                  .filter((item) => item._id !== id)
                  .map((item) => (
                    <div key={item._id} className="px-1">
                      <ProductCard
                        item={item}
                        disableCartIcon={false}
                        className=""
                      />
                    </div>
                  ))}
              </Slider>
            </div>
          </Row>
        )}
      </Container>
    </div>
  );
};

export default SingleProduct;
